import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/webCategoriesGet";

function* webCategoriesGet(action) {
  try {
    let response = yield requestWithSubTenantIfNeeded("get", "swg/categories");
    response.data.sort((a, b) => (a.name < b.name ? -1 : 1));
    yield put(actions.requestSuccess(response.data));
    if (action.resolve) {
      yield call(action.resolve, response.data);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));
    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.WEB_CATEGORIES_GET_REQUEST, webCategoriesGet);
}

export default saga;
